/* eslint-disable @typescript-eslint/no-var-requires */
export enum Env {
  Adobe = 'ADOBE_DTM',
  ApimProductWebSubscriptionKey = 'APIM_PRODUCT_WEB_SUBSCRIPTION_KEY',
  AuthAuthority = 'AUTH_AUTHORITY',
  AuthClientId = 'AUTH_CLIENT_ID',
  AuthRedirect = 'GATSBY_AUTH_REDIRECT_URI',
  AzureServiceRegion = 'AZURE_SERVICE_REGION',
  AzureSubscriptionKey = 'AZURE_SUBSCRIPTION_KEY',
  BrandLong = 'BRAND_NAME_LONG',
  BrandShort = 'BRAND_NAME_SHORT',
  BuildId = 'GATSBY_BUILD_ID',
  CinchEnvironment = 'GATSBY_CINCH_ENVIRONMENT',
  DataDogClientId = 'DATADOG_CLIENT_ID',
  DataDogRumApplicationId = 'DATADOG_RUM_APPLICATION_ID',
  DataDogRumClientToken = 'DATADOG_RUM_CLIENT_TOKEN',
  DeliverySlotAvailabilityServiceUrl = 'DELIVERY_SLOT_AVAILABILITY_SERVICE_URL',
  DeliveryValidationServiceUrl = 'DELIVERY_VALIDATION_SERVICE_URL',
  Env = 'NODE_ENV',
  FeatureToggles = 'FEATURE_TOGGLES',
  FinanceServiceUrl = 'FINANCE_SERVICE_URL',
  GoogleMapsApiKey = 'GOOGLE_GEOCODING_API_KEY',
  IdealPostcodesApiKey = 'IDEAL_POSTCODES_API_KEY',
  IdealPostcodesUrl = 'IDEAL_POSTCODES_URL',
  IdentityServiceUrl = 'IDENTITY_SERVICE_URL',
  InventoryServiceUrl = 'INVENTORY_SERVICE_URL',
  OneTrustUrl = 'ONE_TRUST_URL',
  OrderServiceUrl = 'ORDER_SERVICE_URL',
  PartExServiceUrl = 'PARTEX_SERVICE_URL',
  PartnerServiceUrl = 'PARTNER_SERVICE_URL',
  PaymentServiceUrl = 'PAYMENT_SERVICE_URL',
  PrismicAccessToken = 'PRISMIC_ACCESS_TOKEN',
  RecommendationServiceUrl = 'RECOMMENDATION_SERVICE_URL',
  SegmentKey = 'SEGMENT_KEY',
  SegmentLocalKey = 'SEGMENT_LOCAL_KEY',
  SiteUrl = 'GATSBY_SITE_URL',
  StaticAssetsUrl = 'STATIC_ASSETS_URL',
  StripeKey = 'STRIPE_KEY',
  TracingUrl = 'TRACING_URL',
  UserServiceUrl = 'USER_SERVICE_URL',
  VehicleSearchServiceUrl = 'VEHICLE_SEARCH_SERVICE_URL',
  VehicleServiceUrl = 'VEHICLE_SERVICE_URL',
  WbacServiceUrl = 'WBAC_SERVICE_URL',
}

export const getEnv = (key: Env) => {
  const cinchEnvironment = process.env.GATSBY_CINCH_ENVIRONMENT || 'development'

  const baseStaticConfiguration = require(`./environments/base.json`)
  const environmentStaticConfiguration = require(`./environments/${cinchEnvironment}.json`)

  const env: Record<Env, string> = {
    ...baseStaticConfiguration,

    [Env.AuthRedirect]: process.env.GATSBY_AUTH_REDIRECT_URI || '',
    [Env.BuildId]: process.env.GATSBY_BUILD_ID || '',
    [Env.PrismicAccessToken]: process.env.PRISMIC_ACCESS_TOKEN || '',
    [Env.SiteUrl]: process.env.GATSBY_SITE_URL || '',

    ...environmentStaticConfiguration,
  }

  return env[key]
}
